module.exports = __webpack_public_path__ + "img/2.6.28761df5.jpg";